import {
	isValidNumber,
	parsePhoneNumberFromString as parseMobile,
} from 'libphonenumber-js/custom'

import getLibPhoneNumberMinMetaData from './getLibPhoneNumberMinMetaData'
/**
 * validate the mobile number
 * @param {*} mobileNumber
 */
export default function isValidMobileNumber(mobileNumber) {
	let metadata = getLibPhoneNumberMinMetaData()
	let mobileMetaData = getLibPhoneNumberMinMetaData(true)
	if (!metadata || !mobileMetaData) {
		return false
	}
	return (
		isValidNumber(mobileNumber, metadata) &&
		parseMobile(mobileNumber, mobileMetaData).isValid()
	)
}
